import React, { useEffect } from 'react';

const SecurityPolicy = () => {
  // Скролл вверх при загрузке страницы
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-lunar-gradient py-20 px-4">
      <div className="max-w-4xl mx-auto">
        <div className="bg-lunar-800/50 backdrop-blur-sm rounded-2xl p-8 border border-[var(--primary-color-800-30)]">
          <div className="mb-8">
            <h1 className="text-3xl font-bold text-white mb-4">
              Политика безопасности и возврата
            </h1>
            <p className="text-lunar-400">
              Последнее обновление: 13 октября 2025 г. в 12:44
            </p>
          </div>
          
          <div className="space-y-8 text-lunar-300">
            <div>
              <h3 className="font-semibold text-white mb-2">
                Соглашение о политике безопасности и возврата
              </h3>
              <p className="text-lunar-300">
                Настоящее соглашение описывает, как мы обеспечиваем безопасность при обращении с Вашими персональными и финансовыми данными и процедуры возврата продуктов или услуг, предоставляемых нашими сервисами.
              </p>
            </div>

            <div>
              <p className="text-lunar-300">
                В случае, если вам не подходят условия данной Политики, пожалуйста, не используйте наши услуги. Мы гарантируем вашу безопасность на всех этапах использования наших сервисов и товаров.
              </p>
              <p className="text-lunar-300 mt-2">
                Пожалуйста, ознакомьтесь с нашими условиями безопасности и возврата перед оформлением покупки или регистрации на нашем сервисе.
              </p>
            </div>
          </div>

        {/* Основной контент */}
        <div className="space-y-8 text-lunar-300 mt-8">
          {/* 1. Политика безопасности */}
          <section>
            <h2 className="text-xl font-semibold text-white mt-8 mb-4">
              1. Политика безопасности
            </h2>
            
            <div className="space-y-6">
              <div>
                <h3 className="font-semibold text-white mb-3">
                  1.1. Защита персональных и финансовых данных
                </h3>
                <p className="text-lunar-300">
                  Мы применяем современные методы защиты данных, включая шифрование и двухфакторную аутентификацию, чтобы обеспечить безопасность ваших персональных и финансовых данных.
                </p>
              </div>

              <div>
                <h3 className="font-semibold text-white mb-3">
                  1.2. Защищенные транзакции
                </h3>
                <p className="text-lunar-300">
                  Все транзакции осуществляются через защищенные каналы, что гарантирует конфиденциальность информации при передаче.
                </p>
              </div>

              <div>
                <h3 className="font-semibold text-white mb-3">
                  1.3. Мониторинг безопасности
                </h3>
                <p className="text-lunar-300">
                  Мы регулярно проводим проверки системы безопасности для предотвращения угроз и утечек данных.
                </p>
              </div>
            </div>
          </section>

          {/* 2. Процедура возврата */}
          <section>
            <h2 className="text-xl font-semibold text-white mt-8 mb-4">
              2. Процедура возврата
            </h2>
            
            <div className="space-y-6">
              <div>
                <h3 className="font-semibold text-white mb-3">
                  2.1. Условия возврата
                </h3>
                <p className="text-lunar-300">
                  Возврат средств возможен только в случаях, предусмотренных законодательством или политикой возврата Платформы.
                </p>
              </div>

              <div>
                <h3 className="font-semibold text-white mb-3">
                  2.2. Сроки возврата
                </h3>
                <p className="text-lunar-300">
                  Возврат осуществляется в течение 14-ти рабочих дней с момента подтверждения Администрацией правомерности запроса.
                </p>
              </div>

              <div>
                <h3 className="font-semibold text-white mb-3">
                  2.3. Необходимые документы
                </h3>
                <p className="text-lunar-300">
                  Для возврата Пользователю необходимо предоставить оригинал чека, скриншот или другой документ, подтверждающий покупку.
                </p>
              </div>

              <div>
                <h3 className="font-semibold text-white mb-3">
                  2.4. Полный возврат возможен в случаях:
                </h3>
                <div className="space-y-3">
                  <div>
                    <h4 className="font-medium text-white mb-1">2.4.1. Непредоставление товара/доступа</h4>
                    <p className="text-lunar-300 text-sm">
                      Когда товар / доступ не был предоставлен Пользователю в течение 24 (двадцати четырех) часов с момента оплаты, либо был заблокирован для Пользователя без нарушения им своих обязательств по настоящему Соглашению.
                    </p>
                  </div>
                  <div>
                    <h4 className="font-medium text-white mb-1">2.4.2. Ошибочная оплата</h4>
                    <p className="text-lunar-300 text-sm">
                      Оплата была произведена ошибочно, если при этом Пользователь обратился к Администратору с заявлением о возврате денежных средств в период не превышающий 48 (сорока восьми) часов с момента платежа, при этом Пользователь не воспользовался товаром.
                    </p>
                  </div>
                </div>
              </div>

              <div>
                <h3 className="font-semibold text-white mb-3">
                  2.5. Обращение за возвратом
                </h3>
                <p className="text-lunar-300">
                  Для возврата денежных средств Вам необходимо обратиться в техническую поддержку.
                </p>
              </div>
            </div>
          </section>

          {/* 3. Процесс возврата денежных средств */}
          <section>
            <h2 className="text-xl font-semibold text-white mt-8 mb-4">
              3. Процесс возврата денежных средств
            </h2>
            
            <div>
              <h3 className="font-semibold text-white mb-3">
                3.1. Способ возврата
              </h3>
              <p className="text-lunar-300">
                Возврат денежных средств производится на тот же способ оплаты, который был использован для покупки, в течение 14-ти рабочих дней после получения товара обратно.
              </p>
            </div>
          </section>

          {/* 4. Информация о технической поддержке */}
          <section>
            <h2 className="text-xl font-semibold text-white mt-8 mb-4">
              4. Информация о технической поддержке
            </h2>
            
            <div className="space-y-6">
              <div>
                <h3 className="font-semibold text-white mb-3">
                  4.1. Сроки ответа
                </h3>
                <p className="text-lunar-300">
                  Сроки ответа службы технической поддержки зависят от сложности запроса и объема обращений, но не превышают 48-ми рабочих часов (Рабочие дни ПН-ПТ с 09:00 до 21:00).
                </p>
              </div>

              <div>
                <h3 className="font-semibold text-white mb-3">
                  4.2. Контактные данные службы технической поддержки:
                </h3>
                <div className="text-lunar-300 space-y-2">
                  <p>
                    <strong>Email:</strong> 
                    <a href={`mailto:${process.env.REACT_APP_SUPPORT_EMAIL || 'help@gekata.net'}`} className="text-primary-400 hover:underline ml-1">
                      {process.env.REACT_APP_SUPPORT_EMAIL || 'help@gekata.net'}
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </section>

          <div className="mt-12 pt-8 border-t border-[var(--primary-color-800-30)]">
            <div className="text-left">
              <h3 className="text-lg font-semibold text-white mb-4">Контакты для связи</h3>
              <div className="text-lunar-300">
                <p>Email: {process.env.REACT_APP_SUPPORT_EMAIL || 'support@example.com'}</p>
                <p>Телефон: {process.env.REACT_APP_SUPPORT_PHONE || '+7 (000) 000-00-00'}</p>
              </div>
              
              <div className="mt-6 text-sm text-lunar-400">
                <p>{process.env.REACT_APP_COMPANY_NAME || 'Gekata'}</p>
                <p>ИНН: {process.env.REACT_APP_COMPANY_INN || '000000000000'}</p>
                <p>ОГРН: {process.env.REACT_APP_COMPANY_OGRN || '000000000000000'}</p>
                <p>{process.env.REACT_APP_COMPANY_ADDRESS || 'Адрес компании'}</p>
              </div>
            </div>
          </div>
        </div>
        </div>
      </div>
    </div>
  );
};

export default SecurityPolicy;